import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userDetails: {},
  userName: '',
  isExistingUser: false,
  selectedChatID: '',
  feedback: {},
  isUserVerified: '',
  userUnlocksCount: '',
  userAvatar: '',
  userId: '',
  userEmail: '',
  recomendationFilters: {},
  agentRecomendationFilters: {},
  language: 'english',
  isRoleAdmin: false,
  accessToken:'',
  subscriptionStatus: {
    isSubscriptionActive: false,
    isTrialUsed: true,
    isSubscriptionExpired: true,
    canViewData: false,
    shouldShowFreeTrial: false,
    shouldShowPaymentModal: true,
  },
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      state.userDetails = { ...state.userDetails, ...action.payload };
    },
    setUserName: (state, action) => {
      state.userName = action.payload;
    },
    setIsExistingUser: (state, action) => {
      state.isExistingUser = action.payload;
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    setUserEmail: (state, action) => {
      state.userEmail = action.payload;
    },
    setSelectedChatID: (state, action) => {
      state.selectedChatID = action.payload;
    },
    resetSelectedID: (state) => {
      state.selectedChatID = false;
    },
    setFeedBack: (state, action) => {
      state.feedback = {
        ...state.feedback,
        [action.payload.messageId]: action.payload.feedbackType,
      };
    },
    setUserAvatar(state, action) {
      state.userAvatar = action.payload;
    },
    setIsUserVerified(state, action) {
      state.isUserVerified = action.payload;
    },
    setUserUnlocksCount(state, action) {
      state.userUnlocksCount = action.payload;
    },
    setRecomendationFilters(state, action) {
      state.recomendationFilters = action.payload;
    },
    setAgentRecomendationFilters(state, action) {
      state.agentRecomendationFilters = action.payload;
    },
    setLanguage(state, action) {
      state.language = action.payload;
    },
    setIsRoleAdmin(state, action) {
      state.isRoleAdmin = action.payload;
    },
    setAccessToken(state, action) {
      state.accessToken = action.payload;
    },
    setSubscriptionStatus(state, action) {
      state.subscriptionStatus = { ...state.subscriptionStatus, ...action.payload };
    },
    clearUserData: (state) => {
      state.isExistingUser = false;
      state.userDetails = {};
      state.userName = '';
      state.selectedChatID = false;
      state.feedback = {};
      state.recomendationFilters = {};
      state.agentRecomendationFilters = {};
      state.language = '';
      state.isRoleAdmin = false;
      state.userId = '';
      state.userEmail = '';
      state.userAvatar = '';
      state.isUserVerified = '';
      state.userUnlocksCount = '';
      state.subscriptionStatus = {
        isSubscriptionActive: false,
        isTrialUsed: true,
        isSubscriptionExpired: true,
        canViewData: false,
        shouldShowFreeTrial: false,
        shouldShowPaymentModal: true,
      };
    },
  },
});

export const userActions = userSlice.actions;
export default userSlice.reducer;
